import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button, Modal } from "react-bootstrap";
import {
  GearFill,
  HourglassSplit,
  QuestionCircle,
} from "react-bootstrap-icons";
import "../styles/Header.css";

const Header = () => {
  const isTestPort = useMemo(() => {
    return process.env.REACT_APP_PORT?.startsWith("8");
  }, []);

  const navigate = useNavigate();
  const { logout, remainingTime, managerName, userType } = useAuth();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const isAdminUser = userType === "manager";

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleManualClick = () => {
    navigate("/manual");
  };

  const handlePasswordChangeClick = () => {
    setIsSettingsOpen(false);
    navigate("/passwordChange");
  };

  const getTimeStyle = (timeStr) => {
    const baseStyle = "time-display";
    if (!timeStr || timeStr === "만료됨") return `${baseStyle} expired`;

    const parts = timeStr.split(":");
    const totalSeconds = +parts[0] * 3600 + +parts[1] * 60 + +parts[2];
    if (totalSeconds <= 60) return `${baseStyle} warning`;

    return baseStyle;
  };

  return (
    <header className="header-container">
      <div className="header-inner">
        <div className="header-left">
          <h1 className="header-title">
            <img
              src="../../Logo-03.png"
              alt="로고"
              style={{ height: "40px", width: "auto" }}
            />
            <span style={{ position: "relative", top: "-5px" }}>
              주문 시스템
            </span>
            <button
              className="manual-icon-button"
              onClick={handleManualClick}
              title="사용자 매뉴얼"
            >
              <QuestionCircle
                size={20}
                className="manual-icon"
                style={{ position: "relative", top: "-5px" }}
              />
            </button>
            {isTestPort && <span className="test-badge">TEST MODE</span>}
          </h1>
        </div>
        <div className="header-right">
          <label className="badge badge-success">{managerName}</label>
          {remainingTime && (
            <div className={getTimeStyle(remainingTime)}>
              <HourglassSplit size={20} className="hourglass-icon" />
              <span>{remainingTime}</span>
            </div>
          )}
          {isAdminUser && (
            <button
              className="settings-icon-button"
              onClick={() => setIsSettingsOpen(true)}
              title="앱 설정"
              type="button"
            >
              <GearFill size={20} className="settings-icon" />
            </button>
          )}
          <button className="logout-button" onClick={handleLogout}>
            로그아웃
          </button>
        </div>
      </div>
      <Modal
        show={isSettingsOpen}
        onHide={() => setIsSettingsOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>앱 설정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            관리자 계정에서 사용할 수 있는 설정 메뉴입니다.
          </p>
          <div className="d-grid gap-2">
            <Button variant="primary" onClick={handlePasswordChangeClick}>
              비밀번호 변경
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => setIsSettingsOpen(false)}
            >
              닫기
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default Header;
